export class HeaderMega {
  constructor(_targetElem, _motionElems) {
    this.mouseEnterFlag = false;
    this.mouseLeaveFlag = false;
    this.mouseEnterTimeout;
    this.toggleMouseEnterElems = document.querySelectorAll(
      ".js-toggle-mouseenter-item",
    );
    // this.wrapperElem = document.querySelector('#js-wrapper')
    this.excute();
  }
  // init = () => {
  //   this.toggleMouseEnterElems.forEach((toggleMouseEnterElem) => {
  //     toggleMouseEnterElem.classList.remove('is-active-mega')

  //   })
  // }
  excute = () => {
    const _this = this;

    // document.addEventListener('drawerLinkActiveMegaEvent', (e) => {
    //   // console.log(e.detail.message); // "Hello World"
    //   setTimeout(function () {
    //     document.body.classList.remove('is-active-mega')
    //     _this.toggleMouseEnterElems.forEach((toggleMouseEnterElem) => {
    //       toggleMouseEnterElem.classList.remove('is-active-mega')
    //       // toggleMouseEnterElem.removeAttribute('inert')
    //     })
    //   }, 200)
    // });

    this.toggleMouseEnterElems.forEach((toggleMouseEnterElem) => {
      const mouseenterFunc = (e) => {
        e.preventDefault();
        if (window.innerWidth >= 1024) {
          clearTimeout(_this.mouseEnterTimeout);
          document.body.classList.add("is-active-mega");
          toggleMouseEnterElem.classList.add("is-active-mega");
          // toggleMouseEnterElem.setAttribute('inert','')
          _this.mouseEnterFlag = true;
          _this.mouseLeaveFlag = false;
        }
      };
      const mouseleaveFunc = (e) => {
        e.preventDefault();
        _this.mouseEnterTimeout = setTimeout(function () {
          if (!_this.mouseLeaveFlag) {
            toggleMouseEnterElem.classList.remove("is-active-mega");
            // toggleMouseEnterElem.removeAttribute('inert')
          }
        }, 50);
        _this.mouseEnterTimeout = setTimeout(function () {
          _this.mouseEnterFlag = false;
          if (!_this.mouseEnterFlag) {
            document.body.classList.remove("is-active-mega");
            _this.mouseLeaveFlag = true;
          }
        }, 200);
      };
      toggleMouseEnterElem.addEventListener("mouseenter", mouseenterFunc);
      toggleMouseEnterElem.addEventListener("mouseleave", mouseleaveFunc);
    });
  };
}
